import React, { FunctionComponent } from 'react';

import { Divider } from '@yandex-360/orb-components/dist/components/Divider';
import { useSelector } from 'react-redux';

import { i18n } from '../../../../../../../helpers/i18n';
import { selectIsNoiseCancellationEnabled } from '../../../../../../settings';
import { Heading } from '../../../heading';
import { Island } from '../../../island';
import { JoinWithMicrophoneOffTumbler } from '../../../tumblers';
import { InputDeviceSelect } from './input-device-select';
import { NoiseCancellationTumbler } from './noise-cancellation-tumbler';
import { OutputDeviceSelect } from './output-device-select';
import css from './styles.css';

export const SoundSupported: FunctionComponent = () => {
    const isNoiseCancellationEnabled = useSelector(selectIsNoiseCancellationEnabled);
    return (
        <Island className={css.soundWrapper}>
            <Heading title={i18n('settings-v2', 'section-sound-title')} />
            <OutputDeviceSelect />
            <InputDeviceSelect />
            <JoinWithMicrophoneOffTumbler />
            {isNoiseCancellationEnabled && (
                <>
                    <div className={css.dividerWrapper}>
                        <Divider className={css.divider} size="sm" />
                    </div>
                    <NoiseCancellationTumbler />
                </>
            )}
        </Island>
    );
};
